export function beforeDestroy() {
  this.unsubAmenityStore()
}
